import ScrollableSectionComponent from './ScrollableSection.component';

export default ScrollableSectionComponent;
